/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mean_Broad_Rooster_PeekInputs */

const es_mean_broad_rooster_peek = /** @type {(inputs: Mean_Broad_Rooster_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const gl_mean_broad_rooster_peek = /** @type {(inputs: Mean_Broad_Rooster_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico`)
};

const en_mean_broad_rooster_peek = /** @type {(inputs: Mean_Broad_Rooster_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Mean_Broad_Rooster_PeekInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const mean_broad_rooster_peek = /** @type {((inputs?: Mean_Broad_Rooster_PeekInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mean_Broad_Rooster_PeekInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_mean_broad_rooster_peek(inputs)
	if (locale === "en") return en_mean_broad_rooster_peek(inputs)
	return es_mean_broad_rooster_peek(inputs)
});